<template>
  <!-- <div class="vr-expire-bg" v-if="userInfo.expire_status">
    <TopUpTip></TopUpTip>
  </div> -->
  <div class="vr-bg" v-if="vrbase.base">
    <div class="vr-top">
      <div class="title">{{ vrbase.base && vrbase.base.name }}</div>
      <div class="preshow">
        <a-button type="primary" class="header-close" @click="onclickClose">
          <a-icon type="left-circle"></a-icon>
          {{ $t('actionTitles.back') }}
        </a-button>
      </div>
      <div class="close">
        <a-button
          :style="{ marginRight: '10px' }"
          type="primary"
          @click="share"
        >
          <a-icon type="share-alt"></a-icon>
          {{ $t('actionTitles.share') }}
        </a-button>
        <a-button
          :style="{ marginRight: '10px' }"
          type="primary"
          @click="onClickSave"
        >
          <a-icon type="save"></a-icon>
          {{ $t('actionTitles.save') }}
        </a-button>
        <a-button type="primary" @click="preShow">
          <a-icon type="eye"></a-icon>
          {{ $t('actionTitles.preview') }}
        </a-button>
      </div>
    </div>
    <div class="vr-content">
      <div class="vr-left">
        <div
          class="navBtn"
          v-for="(item, index) in btnTitles"
          :key="index"
          :class="{ active: index == currentIndex }"
        >
          <a-button
            type="primary"
            @click="onClickBtn(item, index)"
            style="width: 74px"
          >
            <!-- <a-icon :type="item.icon"></a-icon> -->
            <img :src="item.src" class="vr-left-icon" />
            <br />
            {{ item.title }}
          </a-button>
        </div>
      </div>
      <div
        class="vr-right"
        :style="{ paddingLeft: isGroupMargin ? '256px' : 0 }"
      >
        <!-- 全景圖片 -->
        <div class="vr-container" ref="vr_container">
          <edit-pano ref="editPano" />
          <div
            class="visual"
            :class="visualActive ? 'active' : ''"
            v-if="viewVisible"
          ></div>
          <div class="visual-btn" v-if="viewVisible">
            <a-button type="primary" size="small" @click="onClickSetView">
              {{ $t('actionTitles.setAngle') }}
            </a-button>
          </div>

          <!-- 截圖 -->
          <button
            class="screenShot"
            @click="handleScreenShot2"
          >
            <img src="@/assets/img/screenShot.png" />
            <p>截圖</p>
          </button>

          <!-- ai主播組件 -->
          <digitalHuman
            v-if="videoDom"
            :videoDom="videoDom"
            :aiAnchorHeight="aiAnchorHeight"
          ></digitalHuman>
          <!-- ai主播所需要的video -->
          <video
            ref="videoDoms"
            id="videoDoms"
            crossorigin="anonymous"
            :src="videoUrl"
            loop
            style="
              width: 216px;
              height: 384px;
              position: absolute;
              right: -220px;
              top: 0;
            "
          />
          <a-tooltip placement="left">
            <template slot="title" v-if="totalLeftCount">
              <span>還剩{{ totalLeftCount }}張</span>
            </template>
            <template slot="title" v-else>
              <span>變裝已完成</span>
            </template>
            <div
              v-if="isUsedAITransform"
              class="aigenerateinform-btn"
              @click="handleShowAIGenerateInformModal"
            >
              <img
                src="@/assets/img/AIGenerateInform.png"
                alt="AIGenerateInform"
              />
            </div>
          </a-tooltip>
        </div>
        <!-- 場景分組 -->
        <div class="vr-group">
          <div class="group-top">
            <draggable
              v-model="sceneGroups"
              delay="200"
              delay-on-touch-only="true"
              :distance="1"
              style="display: flex"
              @end="onGroupDragEnd"
            >
              <div
                v-for="(group, index) in sceneGroups"
                :key="index"
                class="group-title"
                :class="{ active: currentGroupIdx === index }"
              >
                <div class="group-title-name" @click="titleClick(index)">
                  {{ group.name }}
                </div>
                <div class="group-title-options">
                  <CPopover>
                    <div slot="content">
                      <div
                        class="options-list"
                        @click="groupOption(index, group, 'rename')"
                      >
                        {{ $t('actionTitles.rename') }}
                      </div>
                      <div
                        class="options-list"
                        @click="
                          groupOption(index, group, 'sceneClassification')
                        "
                      >
                        {{ $t('actionTitles.sceneClassification') }}
                      </div>
                      <div
                        class="options-list"
                        @click="groupOption(index, group, 'delete')"
                      >
                        {{ $t('actionTitles.delete') }}
                      </div>
                    </div>
                  </CPopover>
                </div>
              </div>
            </draggable>
            <div class="group-add-btn" @click="addGroup">+</div>
          </div>

          <div class="group-bottom">
            <div class="item-scroll-container" v-if="sceneGroups.length > 0">
              <div
                class="item-wrapper"
                id="dragContainer"
                @ondragover.prevent.stop="preventDrop"
              >
                <draggable
                  v-model="sceneGroups[currentGroupIdx].scenes"
                  style="display: flex"
                  delay="200"
                  delay-on-touch-only="true"
                  :distance="1"
                  :options="{
                    filter: ' .item-title',
                    preventOnFilter: true,
                  }"
                  @start="onDragStart"
                  @end="onDragEnd"
                >
                  <div
                    class="item-bg"
                    v-for="(sceneIdx, index) in sceneGroups[currentGroupIdx]
                      .scenes"
                    :key="index"
                  >
                    <div class="item-img">
                      <div
                        class="scene-option"
                        @click.stop="(e) => e.preventDefault()"
                      >
                        <CPopover ondragstart="return false">
                          <div slot="content">
                            <p class="options-list-title">
                              {{ '對比圖' }}
                            </p>
                            <div class="options-list">
                              <div
                                class="icon-box"
                                @click="handleTriggerAddTongPing(sceneIdx)"
                              >
                                <div
                                  class="delete-box"
                                  v-if="
                                    vrbase.scenes[sceneIdx].tongping &&
                                    vrbase.scenes[sceneIdx].tongping.thumb_path
                                  "
                                  @click.stop="handleDeleteTongPing(sceneIdx)"
                                >
                                  <a-icon type="delete" class="delete-icon" />
                                </div>
                                <img
                                  v-if="
                                    vrbase.scenes[sceneIdx].tongping &&
                                    vrbase.scenes[sceneIdx].tongping.thumb_path
                                  "
                                  :src="
                                    vrbase.scenes[sceneIdx].tongping.thumb_path
                                  "
                                  alt=""
                                  class="img-box"
                                />
                                <a-icon type="plus" class="jiahaoicon" v-else />
                              </div>
                            </div>
                            <!-- <div
                              class="options-list bot-border"
                            >
                              {{ $t('actionTitles.tongPing') }}
                            </div> -->
                            <div
                              v-if="false"
                              class="options-list"
                              @click="handleShowAITutorialModal(sceneIdx)"
                            >
                              {{ 'AI變裝' }}
                            </div>
                            <div
                              @click="hideScene(sceneIdx)"
                              class="options-list"
                            >
                              {{ '隱藏全景圖' }}
                            </div>
                            <div
                              class="options-list"
                              @click="sceneOption(index, sceneIdx, 'rename')"
                            >
                              {{ $t('actionTitles.rename') }}
                            </div>
                            <div
                              class="options-list"
                              @click="sceneOption(index, sceneIdx, 'delete')"
                            >
                              {{ $t('actionTitles.delete') }}
                            </div>
                          </div>
                        </CPopover>
                      </div>
                      <img
                        @click="loadScene(sceneIdx)"
                        :src="
                          vrbase.scenes && vrbase.scenes[sceneIdx].thumb_path
                        "
                        alt="img"
                        :style="{
                          border:
                            sceneIdx === currentScenesId
                              ? '2px solid #015c61'
                              : '',
                        }"
                        class="scene-img"
                      />
                      <!-- <div class="hide-scene" @click="loadScene(sceneIdx)">
                        <img
                          src="@/assets/img/hideScene.png"
                          alt="hide scene"
                        />
                      </div> -->
                    </div>
                    <div
                      class="item-title"
                      onselectstart="return false;"
                      ondragstart="return false"
                    >
                      {{ vrbase.scenes && vrbase.scenes[sceneIdx].scene_title }}
                    </div>
                  </div>
                </draggable>
                <div class="add-scenes m-right-10" @click="addScene">
                  <a-icon type="plus" />
                  <h4>{{ $t('moduleTitles.panoList') }}</h4>
                </div>
                <div class="add-scenes" @click="addPanpramic">
                  <a-icon type="plus" />
                  <h4>{{ $t('moduleTitles.panoramic') }}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Settings v-if="settingVisible"></Settings>

      <tool-drawer :visible="injectVisible">
        <template slot="body">
          <InjectPannel></InjectPannel>
        </template>
      </tool-drawer>

      <tool-drawer :visible="hotspotVisible">
        <template slot="body">
          <HotspotPannel></HotspotPannel>
        </template>
      </tool-drawer>

      <tool-drawer :visible="sandboxVisible">
        <template slot="body">
          <SandboxPannel></SandboxPannel>
        </template>
      </tool-drawer>

      <tool-drawer :visible="naviVisible">
        <template slot="body">
          <NaviPannel></NaviPannel>
        </template>
      </tool-drawer>

      <tool-drawer :visible="viewVisible">
        <template slot="body">
          <ViewPannel></ViewPannel>
        </template>
      </tool-drawer>

      <tool-drawer :visible="autoVisible">
        <template slot="body">
          <AutoWalkPannel></AutoWalkPannel>
        </template>
      </tool-drawer>

      <tool-drawer :visible="specialVisible">
        <template slot="body">
          <Special></Special>
        </template>
      </tool-drawer>

      <tool-drawer :visible="maskVisible">
        <template slot="body">
          <MaskPanner></MaskPanner>
        </template>
      </tool-drawer>

      <tool-drawer :visible="aiVisible">
        <template slot="body">
          <AiPanner
            @change="changeAiAnchor"
            @videoChange="playVideoDom"
          ></AiPanner>
        </template>
      </tool-drawer>

      <!-- 標尺面板 -->
      <tool-drawer :visible="rulerVisible">
        <template slot="body">
          <RulerPanner></RulerPanner>
        </template>
      </tool-drawer>
      <!-- 沙盤場景 -->
      <div
        class="sand-box-edit-base"
        v-if="isSandSceneDraw && editSandtable.url"
      >
        <ImageDrawer
          mode="edit"
          :visible="isSandSceneDraw"
          left="350px"
        ></ImageDrawer>
      </div>

      <!--add group modal-->
      <a-modal
        v-model="groupMVisible"
        :title="
          isExistingGroup
            ? $t('actionTitles.sceneClassification')
            : $t('actionTitles.addGroups')
        "
        :width="600"
        :footer="null"
        :destroyOnClose="true"
        :afterClose="() => (isExistingGroup = false)"
      >
        <AddGroup
          v-show="!isExistingGroup"
          @closeModal="groupMVisible = false"
        ></AddGroup>
        <AddGroup
          v-show="isExistingGroup"
          @closeModal="groupMVisible = false"
          :currentNum="1"
          :currGroupIndex="groupCurrIndex"
          :existingGroup="existingGroup"
        ></AddGroup>
      </a-modal>
      <!--add scenes modal-->
      <HMaterialModal
        :visible="scenesVisible"
        :isFilterScence="true"
        @close="scenesVisible = false"
        @handleConfirm="scenesConfirm"
        :type="2"
      ></HMaterialModal>

      <HMaterialModal
        :visible="panoramicVisible"
        :isFilterScence="true"
        @close="panoramicVisible = false"
        @handleConfirm="scenesConfirm"
        :type="1"
      ></HMaterialModal>
      <HMaterialModal
        :visible="tongPingVisible"
        :isFilterScence="true"
        @close="tongPingVisible = false"
        @handleConfirmTongPing="
          (scene) => handleAddTongPing(selectTongPingId, scene)
        "
        :type="3"
      ></HMaterialModal>
    </div>

    <!--重命名-->
    <a-modal
      v-model="renameVisible"
      :title="$t('actionTitles.rename')"
      :destroyOnClose="true"
      @ok="handleConfirm"
    >
      <div>
        <div>
          <a-input
            v-model="newName"
            :addonBefore="$t('descriptions.renameHeader')"
            :placeholder="oldName"
          ></a-input>
        </div>
      </div>
    </a-modal>
    <!--分享-->
    <a-modal
      v-model="shareVisible"
      :title="$t('actionTitles.share')"
      :width="800"
      :destroyOnClose="true"
      @ok="() => (this.shareVisible = false)"
    >
      <Share :workId="VRObject.base && VRObject.base.uuid"></Share>
    </a-modal>
    <!--退出前確認保存-->
    <a-modal
      v-model="quitVisible"
      :width="416"
      :destroyOnClose="true"
      :footer="null"
    >
      <Confirm
        :content="$t('edit.editMessage.backContent')"
        :cancelTxt="$t('edit.editMessage.backCancelText')"
        :okTxt="$t('edit.editMessage.backOkText')"
        @onclickOk="quitOkConfirm"
        @onclickCancel="quitCancelConfirm"
      ></Confirm>
    </a-modal>
    <!--預覽確認保存-->
    <!-- <a-modal
      v-model="tourConfirmVisible"
      :width="416"
      :destroyOnClose="true"
      :footer="null"
    >
      <Confirm
        :content="$t('edit.editMessage.content2')"
        :cancelTxt="$t('actionTitles.cancel')"
        :okTxt="$t('edit.editMessage.preConfirm')"
        @onclickOk="tourOkConfirm"
        @onclickCancel="tourConfirmVisible = false"
      ></Confirm>
    </a-modal> -->
    <AITutorialModal
      v-model="isShowAITutorialModal"
      @input="isShowAITransformModal = true"
    />
    <AITransformModal
      v-if="isShowAITransformModal"
      v-model="isShowAITransformModal"
      :vrbase="vrbase"
      :AITransformSceneID="AITransformSceneID"
      :handleGenerate="handleGenerate"
    />
    <AIGenerateInformModal
      v-if="isShowAIGenerateInformModal"
      v-model="isShowAIGenerateInformModal"
      :completedCount="completedCount"
      :totalGenerated="totalGenerated"
      :percent="percent"
      :handleAddTongPing="handleAddTongPing"
      :AITransformedSceneID="AITransformedSceneID"
    />
  </div>
</template>
<script>
import Settings from './component/setting';
import Special from './component/special';
import InjectPannel from './component/inject';
import HotspotPannel from './component/hotpoint';
import SandboxPannel from './component/sandbox';
import NaviPannel from './component/navi';
import ViewPannel from './component/view';
import ToolDrawer from './component/ToolDrawer';
import AutoWalkPannel from './component/walk';
import ImageDrawer from '@/components/ImageDrawer';
import EditPano from './component/EditPano';
import AddGroup from './component/AddGroup.vue';
import HMaterialModal from '@/components/HMaterialModal';
import AITutorialModal from '@/components/AITutorialModal';
import AITransformModal from '@/components/AITransformModal';
import AIGenerateInformModal from '@/components/AIGenerateInformModal';
import CPopover from './component/CPopover';
import { mapGetters } from 'vuex';
import { v4 as uuidv4 } from 'uuid';
import { getWorkDetail } from '@/api/work';
import Share from '@/components/Share';
import draggable from 'vuedraggable';
import Confirm from '@/components/Confirm';
import RulerPanner from './component/ruler';
import MaskPanner from './component/setting/component/MaskSetting.vue';
import digitalHuman from '../../../public/ssr/components/digitalHuman/Index';
import AiPanner from './component/ai/Index';
import aitransformData from '@/assets/js/aitransformData.json';

export default {
  components: {
    AiPanner,
    MaskPanner,
    Settings,
    InjectPannel,
    HotspotPannel,
    SandboxPannel,
    NaviPannel,
    ViewPannel,
    AutoWalkPannel,
    ToolDrawer,
    ImageDrawer,
    EditPano,
    AddGroup,
    HMaterialModal,
    AITutorialModal,
    AITransformModal,
    AIGenerateInformModal,
    CPopover,
    Share,
    draggable,
    Confirm,
    Special,
    RulerPanner,
    digitalHuman,
  },
  data() {
    return {
      workId: 0,
      employeeId: 0, //普通用戶進入存放的用戶id，退出時用
      visible: false,
      btnTitles: [
        {
          title: this.$t('edit.vrAutoShow'),
          type: 'auto',
          icon: 'history',
          src: require('@/assets/img/edit_icon_auto.png'),
        },
        {
          title: this.$t('edit.hotpoint'),
          type: 'hotpoint',
          icon: 'pushpin',
          src: require('@/assets/img/edit_icon_hotpoint.png'),
        },
        {
          title: this.$t('edit.inject'),
          type: 'inject',
          icon: 'file-image',
          src: require('@/assets/img/edit_icon_inject.png'),
        },
        {
          title: this.$t('edit.vrView'),
          type: 'view',
          icon: 'scan',
          src: require('@/assets/img/edit_icon_view.png'),
        },
        {
          title: this.$t('edit.vrNavi'),
          type: 'navi',
          icon: 'flag',
          src: require('@/assets/img/edit_icon_navi.png'),
        },
        {
          title: this.$t('edit.snadbox'),
          type: 'sandbox',
          icon: 'control',
          src: require('@/assets/img/edit_icon_sandbox.png'),
        },
        {
          title: this.$t('edit.special'),
          type: 'special',
          icon: 'bg-colors',
          src: require('@/assets/img/edit_icon_special.png'),
        },
        {
          title: this.$t('edit.ruler.ruler'),
          type: 'ruler',
          icon: 'line',
          src: require('@/assets/img/edit_icon_ruler.png'),
        },
        {
          title: this.$t('edit.mask'),
          type: 'mask',
          icon: 'mask',
          src: require('@/assets/img/edit_icon_mask.png'),
        },
        {
          title: this.$t('edit.ai'),
          type: 'ai',
          icon: 'ai',
          src: require('@/assets/img/edit_icon_ai.png'),
        },
        {
          title: this.$t('edit.setting'),
          type: 'setting',
          icon: 'setting',
          src: require('@/assets/img/edit_icon_setting.png'),
        },
      ],

      currentIndex: -1,
      currentShowType: '',
      // currentTabComponent: "",
      // tourConfirmVisible: false,
      quitVisible: false,
      injectVisible: false,
      hotspotVisible: false,
      settingVisible: false,
      sandboxVisible: false,
      naviVisible: false,
      viewVisible: false,
      autoVisible: false,
      specialVisible: false,
      aiVisible: false, //AI主播是否顯示
      isSandSceneDraw: false,
      isGroupMargin: false,
      sandScenes: {},
      VRObject: {},
      currentGroupIdx: 0,
      sceneGroups: [],
      groupMVisible: false,
      scenesVisible: false,
      optionsVisible: false,
      renameVisible: false,
      shareVisible: false,
      oldName: '',
      renameObj: {},
      newName: '',
      shareUrl: '',
      vrLoadingKey: 'vrLoadingKey',
      visualActive: false,
      isExistingGroup: false,
      existingGroup: {},
      panoramicVisible: false, //全景視頻
      groupCurrIndex: -1, //當前操作的group的index
      rulerVisible: false,
      maskVisible: false,

      //ai主播組件所需
      videoDom: null,
      videoUrl: '',
      tongPingVisible: false,
      selectTongPingId: '',
      aiAnchorHeight: 500,
      isShowAITransformModal: false,
      isShowAITutorialModal: false,
      isShowAIGenerateInformModal: false,
      // AI變裝
      isUsedAITransform: false, // 是否有使用過AI變裝
      AITransformSceneID: '', // AI變裝的場景ID
      AITransformScene: undefined, // AI變裝的場景
      AITransformedSceneID: '', // AI變裝後的場景ID
      totalGenerated: 0, // 總共生成的數量
      completedCount: 0, // 已經倒數完的數量
      percent: 0, // 百分比
      vr_container: null,
    };
  },
  computed: {
    ...mapGetters(['vrbase', 'currentScenesId', 'editSandtable', 'userInfo']),
    show: {
      get: function () {
        return this.isShow;
      },
      set: function () {},
    },
    totalLeftCount() {
      return this.totalGenerated - this.completedCount;
    },
  },
  created() {
    document.body.ondrop = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };
    this.$store.dispatch('getUserInfo'); //更新用戶的配置
    // if (this.userInfo.expire_status) {
    //   return;
    // }
    this.workId = Number(this.$route.query.id);
    this.employeeId = Number(this.$route.query.employeeId);
    this.$message.loading({
      content: ' ',
      key: this.vrLoadingKey,
    });
    getWorkDetail({ id: this.workId }).then((res) => {
      if (res.data) {
        this.VRObject = res.data;
        if (
          this.userInfo.type != 1 &&
          this.userInfo.type != 3 &&
          this.VRObject.base.uid != this.userInfo.id
        ) {
          this.$message.error(this.$t('message.noPower'));
          return;
        }
        // 獲取第一個場景id
        this.getFirstSenceFromAll();
        this.$store.dispatch('setVRBase', this.VRObject).then((res) => {
          initVrshowVue(this);
          setWork(this.vrbase);
          setMode('edit');
          setTourXml(`/api/tourXml?id=${this.workId}`);
          launchKrpano(null, '/ssr/static/tour/tour.swf');
          // 處理分享地址
          this.handleShareUrl();

          //AI主播相關
          this.$nextTick(() => {
            this.videoDom = this.$refs.videoDoms;
          });
        });
        this.sceneGroups = this.vrbase.scene_group.groups;
      }
      this.$message.destroy();
    });
    //獲取用戶修改權限配置
    this.$store.dispatch('getUserConfig');
  },
  mounted() {
    this.$bus.$on('handleSandboxScene', (data) => {
      this.isSandSceneDraw = true;
      this.sandScenes = data;
    });

    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  methods: {
    preventDrop(event) {
      event.stopPropagation();
      event.preventDefault();
    },
    // dragstart(event, data) {
    //   console.log("drag");
    //   event.dataTransfer.setData("item", data);
    // },
    // dragend(event) {
    //   event.dataTransfer.clearData();
    // },
    // drop(event) {
    //   console.log("drop");
    //   let data = event.dataTransfer.getData("item");
    //   this.dropData = data;
    //   console.log("data: ", data);
    // },

    handleConfirm() {
      console.log('觸發handleConfirm');
      if (this.newName === '') return;
      if (this.renameObj.name) {
        // group更名
        // 循環數組，找到對應的更名對像
        // this.sceneGroups.forEach((item) => {
        //   if (item.name === this.renameObj.name) item.name = this.newName;
        // });
        // 根據當前點的group index來修改分組名稱（防止有相同名字）
        this.$set(this.sceneGroups[this.groupCurrIndex], 'name', this.newName);
        this.vrbase.scene_group.groups = this.sceneGroups;
      }
      if (this.renameObj.scene_title) {
        // sence更名
        this.vrbase.scenes[this.renameObj.scene_id].scene_title = this.newName;
      }
      this.$store.dispatch('setVRBase', this.vrbase);
      // 更新服務器
      // this.$store.dispatch("saveVRBase", {vrbase: this.vrbase, showLoading: true});
      this.renameVisible = false;
      // reset data
      this.newName = '';
      this.oldName = '';
      this.groupCurrIndex = -1;
    },
    groupOption(groupIndex, group, type) {
      if ('rename' === type) {
        this.renameObj = group;
        this.oldName = group.name;
        this.groupCurrIndex = groupIndex;
        this.renameVisible = true;
      }
      if ('delete' === type) {
        const _this = this;
        this.$confirm({
          title: _this.$t('edit.editMessage.title'),
          content: _this.$t('edit.editMessage.content'),
          okText: _this.$t('edit.editMessage.okText'),
          okType: 'danger',
          cancelText: _this.$t('edit.editMessage.cancelText'),
          onOk() {
            _this.handleDeleteGroup(groupIndex, group);
          },
          onCancel() {
            console.log('取消');
          },
        });
      }
      if ('sceneClassification' === type) {
        this.existingGroup = group;
        this.isExistingGroup = true;
        this.groupMVisible = true;
        this.groupCurrIndex = groupIndex;
      }
    },
    handleDeleteGroup(groupIndex, group) {
      if (this.sceneGroups.length == 1) {
        this.$message.error(this.$t('edit.editMessage.deleteGroup'));
        return;
      }
      //過濾刪除的組
      let newList = [];
      this.sceneGroups.forEach((item) => {
        if (item.name !== group.name) newList.push(item);
      });
      if (this.currentGroupIdx === groupIndex) {
        this.currentGroupIdx = newList.length - 1;
      }
      this.sceneGroups = newList;
      this.vrbase.scene_group.groups = this.sceneGroups;
      //被刪除組裡面的場景也要刪除
      const sencesList = group.scenes;
      for (var i = 0; i < sencesList.length; i++) {
        this.$delete(this.vrbase.scenes, sencesList[i]);
      }
      this.$store.dispatch('setVRBase', this.vrbase);
      this.setCurrentSenceToNew(sencesList);
      // 更新服務器
      // this.$store.dispatch("saveVRBase", {vrbase: this.vrbase, showLoading: true});
    },
    sceneOption(groupIndex, sceneIdx, type) {
      if ('rename' === type) {
        this.renameObj = this.vrbase.scenes[sceneIdx];
        this.oldName = this.vrbase.scenes[sceneIdx].scene_title;
        this.renameVisible = true;
      }
      if ('delete' === type) {
        const _this = this;
        this.$confirm({
          title: _this.$t('edit.editMessage.title'),
          content: _this.$t('edit.editMessage.content'),
          okText: _this.$t('edit.editMessage.okText'),
          okType: 'danger',
          cancelText: _this.$t('edit.editMessage.cancelText'),
          onOk() {
            _this.handleDeleteScene(sceneIdx);
          },
          onCancel() {
            console.log('取消');
          },
        });
      }
    },

    handleDeleteScene(sceneIdx) {
      // 至少要保留一個場景
      if (Object.keys(this.vrbase.scenes).length === 1) {
        this.$message.error(this.$t('edit.editMessage.deleteScene'));
        return;
      }
      // 場景對像刪除
      this.$delete(this.vrbase.scenes, sceneIdx);
      // this.sceneGroups = this.vrbase.scenes[sceneIdx];
      // 分組內部的場景刪除，需要遍歷全部分組的全部場景刪除對應id
      for (var i = 0; i < this.sceneGroups.length; i++) {
        let sceneIdList = this.sceneGroups[i].scenes;
        const filArr = sceneIdList.filter((item) => item !== sceneIdx);
        this.sceneGroups[i].scenes = filArr;
        this.$set(this.sceneGroups, i, this.sceneGroups[i]);
      }
      this.vrbase.scene_group.groups = this.sceneGroups;
      this.$store.dispatch('setVRBase', this.vrbase);
      this.setCurrentSenceToNew([sceneIdx]);
      // 更新服務器
      // this.$store.dispatch("saveVRBase", {vrbase: this.vrbase, showLoading: true});
    },
    // 當前場景被刪除後需要重新制定場景, 當前分組沒有就到全部場景中去取第一個，否則取分組第一個
    setCurrentSenceToNew(deletedSenceIdList) {
      if (!deletedSenceIdList.includes(this.currentScenesId)) return;
      const currentGroupSences = this.sceneGroups[this.currentGroupIdx].scenes;
      if (currentGroupSences && currentGroupSences.length > 0) {
        this.$store.dispatch('setCurrentScnId', currentGroupSences[0]);
      } else {
        this.getFirstSenceFromAll();
      }
      this.loadScene(this.currentScenesId);
    },

    // 獲取全部場景的第一個場景、
    getFirstSenceFromAll() {
      const scenesArr = Object.keys(this.VRObject.scenes);
      const currId =
        scenesArr.length > 0
          ? this.VRObject.scenes[scenesArr[0]]['scene_id']
          : '';
      this.$store.dispatch('setCurrentScnId', currId);
    },
    // 取當前分組中最後一個場景的sort_order
    getLastSceneSortOrder() {
      const currGroupCenceList = this.sceneGroups[this.currentGroupIdx].scenes;
      let lastSortNum = 0;
      if (currGroupCenceList && currGroupCenceList.length > 0) {
        const lastSceneId = currGroupCenceList.slice(-1)[0];
        lastSortNum = this.VRObject.scenes[lastSceneId].sort_order;
      }
      return lastSortNum;
    },
    titleClick(index) {
      this.currentGroupIdx = index;
    },
    addScene() {
      this.scenesVisible = true;
    },
    //開始拖動
    onDragStart(evt) {
      evt.item.style.opacity = 0;
      evt.to.ondrop = function (event) {
        event.preventDefault();
        event.stopPropagation();
      };
    },
    //移動場景後處理順序
    onDragEnd(event) {
      event.item.style.opacity = 1;

      event.preventDefault();
      event.stopPropagation();
      const oldIndex = event.oldIndex;
      const newIndex = event.newIndex;
      if (oldIndex === newIndex) return;
      // 獲取當前分組的場景列表
      const currGroupCenceList = this.sceneGroups[this.currentGroupIdx].scenes;
      //按照列表順序，重新從0開始賦值sort_order
      for (let i = 0; i < currGroupCenceList.length; i++) {
        const sceneId = this.sceneGroups[this.currentGroupIdx].scenes[i];
        this.vrbase.scenes[sceneId].sort_order = i;
      }
      this.updateStore(this.vrbase);
      // 更新服務器
      // this.$store.dispatch("saveVRBase", {vrbase: this.vrbase, showLoading: true});
    },
    scenesConfirm(list) {
      console.log('觸發scenesConfirm list:', list);
      if (!list || list.length === 0) {
        this.$message.error(this.$t('edit.editMessage.sceneConfirm'));
        return;
      }
      // 為了變裝所以有改
      // 原本
      // let type = this.scenesVisible ? 0 : 1;
      // 改成
      let type = this.scenesVisible ? 0 : list[0].dir_id == 1070310 ? 0 : 1;
      if (this.scenesVisible) {
        this.scenesVisible = false;
      } else {
        this.panoramicVisible = false;
      }
      let newAddScenes = {};
      let newAddScenesArr = [];

      let tempGroup = undefined;
      console.log('list:', list);
      if (
        list[0].dir_id == 1070310 &&
        (list[0].id == 'pano_27c4948ab1b2f018' ||
          list[0].id == 'pano_4896d4d222ea3670')
      ) {
        tempGroup = 0;
      } else if (
        list[0].dir_id == 1070310 &&
        (list[0].id == 'pano_5dab7bf6ee0eeff3' ||
          list[0].id == 'pano_87c87c4b4bb20621')
      ) {
        tempGroup = 1;
      }

      //獲取選擇的場景id並加入對應分組的scene
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        // 新增場景到model的scenes下
        let sceneStr = uuidv4().replace(/-/g, '');
        let newScene = {
          scene_id: 'scene_' + sceneStr.substr(sceneStr.length - 16),
          type: type,
          pid: item.id,
          // gid: this.sceneGroups[this.currentGroupIdx].id,
          gid: this.sceneGroups[tempGroup ? tempGroup : this.currentGroupIdx]
            .id,
          sort_order: this.getLastSceneSortOrder() + 1,
          scene_title: item.type == 4 ? item.name : item.filename,
          thumb_path: item.type == 4 ? item.cover : item.thumb_path,
          prefix: item.type == 4 ? '' : item.prefix,
          multires: item.type == 4 ? '' : item.multires,
          // location: item.url,
          location: list[0].dir_id == 1070310 ? item.location : item.url,
          paster: {},
          hotspot: {},
          angle: {
            initview: {
              hlookat: 0,
              vlookat: 0,
            },
            fovrange: {
              min: 0,
              max: 140,
              default: 120,
            },
            viewrange: {
              hview: { min: -180, max: 180 },
              vview: { min: -90, max: 90 },
            },
          },
        };
        console.log('newScene:', newScene);
        newAddScenes[newScene.scene_id] = newScene; //提供給沙盤使用
        newAddScenesArr.push(newScene);
        this.$set(this.vrbase.scenes, newScene.scene_id, newScene);
        // this.sceneGroups[this.currentGroupIdx].scenes.push(newScene.scene_id);
        this.sceneGroups[
          tempGroup ? tempGroup : this.currentGroupIdx
        ].scenes.push(newScene.scene_id);
        this.AITransformedSceneID = newScene.scene_id;
      }

      // eslint-disable-next-line
      addScenes(newAddScenesArr);
      this.loadScene(this.currentScenesId);
      this.updateStore(this.vrbase);
      this.$store
        .dispatch('saveVRBase', { vrbase: this.vrbase, showLoading: true })
        .then((res) => {
          if (res && Object.keys(res.data).length > 0) {
            this.vrbase.scenes = res.data.scenes;
            this.VRObject.scenes = res.data.scenes;
          }
        });

      // console.log('newAddScenes:', newAddScenes);
      console.log('newAddScenesArr:', newAddScenesArr);
      return newAddScenesArr;
    },
    addGroup() {
      this.groupMVisible = true;
    },
    loadScene(sceneId) {
      this.$store.dispatch('loadScene', sceneId);
    },
    onClickBtn(item, index) {
      if (this.currentShowType === item.type) {
        const changeStatus = {
          inject: () => (this.injectVisible = !this.injectVisible),
          hotpoint: () => (this.hotspotVisible = !this.hotspotVisible),
          sandbox: () => {
            this.sandboxVisible = !this.sandboxVisible;
            this.isSandSceneDraw = this.sandboxVisible;
            return this.sandboxVisible;
          },
          navi: () => (this.naviVisible = !this.naviVisible),
          view: () => (this.viewVisible = !this.viewVisible),
          auto: () => (this.autoVisible = !this.autoVisible),
          setting: () => (this.settingVisible = !this.settingVisible),
          special: () => (this.specialVisible = !this.specialVisible),
          ruler: () => (this.rulerVisible = !this.rulerVisible),
          mask: () => (this.maskVisible = !this.maskVisible),
          ai: () => (this.aiVisible = !this.aiVisible),
        };
        const isShow = changeStatus[item.type]();
        this.handleGroupMargin(isShow);
        this.toggleKrContent();
        this.closeAi();
        // this.setVisibleArr()
        return;
      }
      this.currentIndex = index;
      this.currentShowType = item.type;
      const type = item.type;
      const handlerObj = {
        inject: type === 'inject',
        hotpoint: type === 'hotpoint',
        sandbox: type === 'sandbox',
        navi: type === 'navi',
        view: type === 'view',
        auto: type === 'auto',
        setting: type === 'setting',
        special: type === 'special',
        ruler: type === 'ruler',
        mask: type === 'mask',
        ai: type === 'ai',
      };

      this.injectVisible = handlerObj['inject'];
      this.hotspotVisible = handlerObj['hotpoint'];
      this.settingVisible = handlerObj['setting'];
      this.sandboxVisible = handlerObj['sandbox'];
      this.naviVisible = handlerObj['navi'];
      this.viewVisible = handlerObj['view'];
      this.autoVisible = handlerObj['auto'];
      this.rulerVisible = handlerObj['ruler'];
      this.specialVisible = handlerObj['special'];
      this.maskVisible = handlerObj['mask'];
      this.aiVisible = handlerObj['ai'];
      this.handleGroupMargin(!this.settingVisible);

      this.isSandSceneDraw = handlerObj['sandbox'];
      this.toggleKrContent();
      this.closeAi();
      // this.setVisibleArr()
    },
    //關閉ai主播
    closeAi() {
      //關閉ai主播的展示
      window.updateAiAnchor({ type: 'reset', value: '' });
      this.videoUrl = '';
    },
    //設置visibleArr數據
    // setVisibleArr() {
    //     this.visibleArr = [
    //         this.autoVisible,
    //         this.hotspotVisible,
    //         this.injectVisible,
    //         this.viewVisible,
    //         this.naviVisible,
    //         this.sandboxVisible,
    //         this.rulerVisible,
    //         this.settingVisible
    //     ]
    // },
    toggleKrContent() {
      toggleEditPasterVisible(this.injectVisible); //krpanoBridge 內的 function
      toggleEditHotspotVisible(this.hotspotVisible); //krpanoBridge 內的 function
      toggleEditGuidePointVisible(this.naviVisible); //krpanoBridge 內的 function
      toggleEditSceneHotspotVisible(this.autoVisible); //krpanoBridge 內的 function
      toggleSunEpecialHotspotVisible(this.specialVisible); //krpanoBridge 內的 function
      toggleEditRulerVisible(this.rulerVisible); //krpanoBridge 內的 function
      this.maskVisible
        ? this.handleShade(this.currentScenesId)
        : this.hiddenShade(this.maskVisible);
    },
    hiddenShade(value) {
      const skyMaskId = 'shade_sky_mask_id';
      const groundMaskId = 'shade_ground_mask_id';
      let key = 'visible';
      setShadeScale(skyMaskId, key, value);
      setShadeScale(groundMaskId, key, value);
      // let date = "";
      // removeAllShade(skyMaskId, groundMaskId);
      // addSceneShade(groundMaskId, date, 90);
      // addSceneShade(skyMaskId, date, -90)
    },
    handleGroupMargin(value) {
      this.isGroupMargin = value;
    },
    handleShade(sceneId) {
      const skyMaskId = 'shade_sky_mask_id';
      const groundMaskId = 'shade_ground_mask_id';
      let date = new Date();
      let currentDateParam =
        '?v=' +
        date.getFullYear() +
        '' +
        (date.getMonth() + 1) +
        '' +
        date.getDate();
      removeAllShade(skyMaskId, groundMaskId);
      //global
      const mask_global_settings = this.vrbase.ads.fix_logo;
      //sceene
      const mask_scene_settings = this.vrbase.scenes[sceneId].sky_land_shade;
      if (mask_scene_settings && mask_scene_settings.land) {
        addSceneShade(
          groundMaskId,
          mask_scene_settings.land + currentDateParam,
          90,
          1,
          0
        );
      } else if (mask_global_settings && mask_global_settings.land) {
        addSceneShade(
          groundMaskId,
          mask_global_settings.land + currentDateParam,
          90,
          mask_global_settings.land_scale,
          mask_global_settings.land_angle
        );
      }
      if (mask_scene_settings && mask_scene_settings.sky) {
        addSceneShade(
          skyMaskId,
          mask_scene_settings.sky + currentDateParam,
          -90,
          1,
          0
        );
      } else if (mask_global_settings && mask_global_settings.sky) {
        addSceneShade(
          skyMaskId,
          mask_global_settings.sky + currentDateParam,
          -90,
          mask_global_settings.sky_scale,
          mask_global_settings.sky_angle
        );
      }
    },
    handleChange() {},
    onChange() {},
    handleShareUrl() {
      // let routeUrl = this.$router.resolve({
      //   path: "/tour",
      //   query: { id: this.vrbase.base.id },
      // });
      let routeUrl = this.$router.resolve({
        name: 'Tour', //這個name就是你剛剛配置在router裡邊的name
        params: {
          id: this.vrbase.base.uuid,
        },
      });
      this.shareUrl = routeUrl.href;
    },
    preShow() {
      // this.tourConfirmVisible = true;
      let isSafari = false;
      if (
        navigator.userAgent.indexOf('Chrome') == -1 &&
        navigator.userAgent.indexOf('Safari') > -1
      ) {
        isSafari = true;
      }
      this.onClickSave().then(() => {
        this.handleShareUrl();
        let self = this;
        if (isSafari) {
          this.$confirm({
            title: self.$t('edit.editMessage.title'),
            content: self.$t('edit.editMessage.prewText'),
            okText: self.$t('actionTitles.yes'),
            cancelText: self.$t('actionTitles.no'),
            okType: 'danger',
            onOk() {
              let index = window.location.href.indexOf('/edit');
              let url = window.location.href.substring(0, index);
              window.open(url + self.shareUrl, '_blank');
            },
            onCancel() {
              self.openNewView(true);
            },
          });
        } else {
          this.openNewView(false);
        }
      });
    },
    //打開一頁
    openNewView(isSafari) {
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.id = 'toTour';
      a.text = 'toTour';
      a.href = this.shareUrl;
      if (!isSafari) a.target = '_blank';
      document.getElementById('toTour').click();
      document.body.removeChild(a);
    },
    // async tourOkConfirm() {
    //   await this.$store.dispatch("saveVRBase", {vrbase: this.vrbase, showLoading: true})
    //   this.handleShareUrl();
    //   let a = document.createElement("a");
    //   document.body.appendChild(a);
    //   a.style = "display: none";
    //   a.target="_blank";
    //   a.id="toTour";
    //   a.text="toTour";
    //   a.href = this.shareUrl;
    //   document.getElementById("toTour").click();
    //   document.body.removeChild(a);
    //   this.tourConfirmVisible = false;
    // },
    share() {
      this.shareVisible = true;
    },
    setting() {},
    inject() {},
    hotPoint() {},
    sandShow() {},
    navShow() {},
    VRview() {},
    VRAutoShow() {},
    // 更新store數據
    updateStore(vrbase) {
      this.$store.dispatch('setVRBase', vrbase);
    },
    //熱點更新回調
    updateHotspot(data) {
      if (
        this.vrbase.scenes[data.scene_id] &&
        this.vrbase.scenes[data.scene_id].hotspot[data.hotspot_id]
      ) {
        const item = this.vrbase.scenes[data.scene_id].hotspot[data.hotspot_id];
        item.ath = data.ath;
        item.atv = data.atv;
        const vrbase = this.vrbase;
        vrbase.scenes[data.scene_id].hotspot[data.hotspot_id].ath = data.ath;
        vrbase.scenes[data.scene_id].hotspot[data.hotspot_id].atv = data.atv;
        console.log(
          '觸發updateHotspot',
          '\nitem:',
          item,
          '\ndata:',
          data,
          '\nvrbase:',
          vrbase
        );
        this.updateStore(vrbase);
      }

      this.$bus.$emit('updateHotspot', data);
    },
    updatePaster(data) {
      if (
        this.vrbase.scenes[data.scene_id] &&
        this.vrbase.scenes[data.scene_id].paster[data.paster_id]
      ) {
        const paster = this.vrbase.scenes[data.scene_id].paster[data.paster_id];
        paster.ath = data.ath;
        paster.atv = data.atv;
        this.updateStore(this.vrbase);
      }

      this.$bus.$emit('updatePaster', data);
    },
    //太陽光坐標更新
    updateSunEffectSetting(sceneId, ath, atv) {
      const data = { ath, atv };
      this.$bus.$emit('updateSunEffectSetting', data);
    },
    clickPaster(sceneId, pasterId) {
      this.$bus.$emit('clickPaster', pasterId);
    },
    updateGuidePoint(data) {
      let vrbase = this.vrbase;
      let point = vrbase.guide[0].points.find(
        (p) => p.point_id == data.point_id
      );
      point.ath = data.ath;
      point.atv = data.atv;
      point.fov = data.fov;
      this.updateStore(vrbase);
    },
    hlookatChange(sceneId, hlookat) {
      if (this.currentHlookat != hlookat) {
        this.$store.dispatch('setCurrentHlookat', hlookat);
      }
    },
    sceneChange(currentSenceId) {
      this.toggleKrContent();
      this.$store.dispatch('setCurrentScnId', currentSenceId);
    },
    // toggleBtns(visible) {},
    // toggleMusicVisible(visible) {},
    // toggleSpeechVisible(visible) {},
    onclickClose() {
      this.quitVisible = true;
    },
    quitOkConfirm() {
      this.quitVisible = false;
      this.onClickSave().then(() => {
        this.quitCancelConfirm();
      });
    },
    quitCancelConfirm() {
      // this.$router.replace({ path: "/member/work" });
      if (this.userInfo.type == 1) {
        this.$router.replace({ path: '/admin/workManage' });
      } else if (this.userInfo.type == 3) {
        if (this.employeeId) {
          this.$router.replace({
            path: '/member/workManage/workList',
            query: { uid: this.employeeId },
          });
        } else {
          this.$router.replace({ path: '/member/work' });
        }
      } else {
        this.$router.replace({ path: '/member/work' });
      }
      this.quitVisible = false;
    },
    onClickSave(showLoading = true) {
      return new Promise((resolve, reject) => {
        // 刪除場景為空的分組
        let cIdx = this.sceneGroups.some((obj) => obj.scenes.length === 0);
        for (var i = 0; i < this.sceneGroups.length; i++) {
          let sceneIdList = this.sceneGroups[i].scenes;
          if (sceneIdList.length === 0) {
            this.sceneGroups.splice(i--, 1);
          }
        }
        if (cIdx) {
          let index = this.sceneGroups.findIndex((o) => {
            return o.scenes.some((scene) => scene == this.currentScenesId);
          });
          this.currentGroupIdx = index;
        }
        this.$store
          .dispatch('saveVRBase', { vrbase: this.vrbase, showLoading })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    onClickSetView() {
      const vrbase = this.vrbase;
      const currView = getSceneViewAt();
      vrbase.scenes[this.currentScenesId].angle.initview =
        this.$deepClone(currView);
      this.visualActive = true;
      setTimeout(() => {
        this.visualActive = false;
      }, 500);
      this.$store.dispatch('saveVRBase', { vrbase, showLoading: true });
    },

    addPanpramic() {
      this.panoramicVisible = true;
    },
    // 觸發增加對比圖
    handleTriggerAddTongPing(sceneIdx) {
      console.log('this.vrbase:', this.vrbase);
      this.tongPingVisible = true;
      this.selectTongPingId = sceneIdx;
    },
    // 增加對比圖
    handleAddTongPing(sceneID, scene) {
      this.vrbase.scenes[sceneID].tongping = {
        scene_id: scene.id,
        thumb_path: scene.thumb_path,
        angle: scene.angle,
      };
      this.$store.dispatch('saveVRBase', {
        vrbase: this.vrbase,
        showLoading: true,
      });
      this.tongPingVisible = false;
    },
    // 刪除對比圖
    handleDeleteTongPing(sceneID) {
      this.vrbase.scenes[sceneID].tongping = {};
      this.$store.dispatch('saveVRBase', {
        vrbase: this.vrbase,
        showLoading: true,
      });
      this.tongPingVisible = false;
    },
    onGroupDragEnd(event) {
      const oldIndex = event.oldIndex;
      const newIndex = event.newIndex;
      if (oldIndex === newIndex) return;
      for (let i = 0; i < this.sceneGroups.length; i++) {
        this.sceneGroups[i].sort_order = i;
      }
      this.vrbase.scene_group.groups = this.sceneGroups;
      this.updateStore(this.vrbase);
    },

    //ai主播數據的改變觸發事件
    changeAiAnchor(newv, oldv) {
      let data = { type: '', value: newv };
      if (newv.anchor_url != oldv.anchor_url) {
        //修改了主播視頻路徑
        this.videoUrl = newv.anchor_url + '?v=' + uuidv4();
        data.type = newv.anchor_url == '' ? 'del' : 'add';
      } else if (newv.color != oldv.color && newv.color) {
        //修改了背景色
        data.type = 'color';
      } else if (newv.position != oldv.position) {
        //改變了位置
        data.type = 'position';
      } else if (newv.size != oldv.size) {
        //改變了大小
        data.type = 'size';
      }
      if (data.type == '') return;
      window.updateAiAnchor(data);
    },
    //接收播放暫停video
    playVideoDom(type) {
      window.editUpdateVideoStatus(type); //挂載視頻播放暫停方法
      const videoDoms = document.getElementById('videoDoms');
      if (type) {
        videoDoms.pause();
      } else {
        videoDoms.play();
      }
    },
    handleResize() {
      if (!this.$refs.vr_container) return;
      this.aiAnchorHeight = this.$refs.vr_container.clientHeight;
    },
    hideScene(sceneID) {
      console.log('sceneID:', sceneID);
    },
    handleShowAITutorialModal(sceneID) {
      this.isShowAITutorialModal = !this.isShowAITutorialModal;
      this.AITransformSceneID = sceneID;
    },
    handleShowAIGenerateInformModal() {
      // console.log('this.AITransformScene:', this.AITransformScene);
      if (!this.AITransformScene) {
        this.$message.error('請等待AI轉換完成');
        return;
      }
      this.isShowAIGenerateInformModal = !this.isShowAIGenerateInformModal;
    },
    handleGenerate(sceneID, styleID, roomID, isAddToTongPing = false) {
      // console.log('sceneID:', sceneID);
      // console.log('styleID:', styleID);
      // console.log('roomID:', roomID);
      // console.log('isAddToTongPing:', isAddToTongPing);
      this.AITransformScene = undefined;
      this.isUsedAITransform = true;
      this.totalGenerated++;

      const interval = setInterval(() => {
        clearInterval(interval);
        this.completedCount++;
        this.percent = (this.completedCount / this.totalGenerated) * 100;
        let response = this.scenesConfirm([aitransformData[styleID]]);
        this.AITransformScene = response[0];
        // console.log('this.AITransformScene:', this.AITransformScene);
        // console.log('response:', response);
        if (!isAddToTongPing) return;
        // console.log('response[0].scene_id:', response[0].scene_id);
        if (styleID == 0 || styleID == 1) {
          this.handleAddTongPing(
            response[0].scene_id,
            this.vrbase.scenes['scene_1aaad70e2ec93ce2'] ||
              this.vrbase.scenes['scene_b44ec47d40d0f554']
          );
        }
        if (styleID == 2 || styleID == 3) {
          this.handleAddTongPing(
            response[0].scene_id,
            this.vrbase.scenes['scene_b97d16b9577894f7'] ||
              this.vrbase.scenes['scene_d8eb2b25bb6f7206']
          );
        }
      }, 20000);
    },
    handleScreenShot2() {
      let krpano = document.getElementById('krpanoSWFObject');
      console.log('krpano:', krpano);
      krpano.call('makescreenshot_init');
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style lang="less" scoped>
.sand-box-edit-base {
  position: absolute;
  top: 5px;
  left: 350px;
  padding: 0;
  /*10px;*/
  background-color: rgba(255, 255, 255, 0.4);
  -webkit-transform-origin: top right;
  -ms-transform-origin: top right;
  transform-origin: top right;
  z-index: 998;
  // width: 290px;
  // max-width: 600px;
  // max-height: 600px;
}

.vr-expire-bg {
  height: 100%;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vr-bg {
  // background-color: #000000;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  color: #fff;
}

.title {
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
}

.vr-top {
  width: 100%;
  height: 50px;
  background-color: rgba(185, 185, 185, 1);
}

.vr-content {
  position: absolute;
  top: 50px;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
}

.vr-left {
  flex: 0 0 88px;
  height: 100%;
  text-align: center;
  background-color: rgba(185, 185, 185, 1);
  overflow: scroll;

  &::-webkit-scrollbar {
    // display: none;
    width: 5px;
  }
}

.vr-right {
  flex: 1;
  height: 100%;
  background-color: rgb(145, 145, 145);
  display: flex;
  flex-direction: column;
}

.preshow {
  position: absolute;
  top: 10px;
  left: 10px;
}

.show {
  position: absolute;
  top: 15px;
  left: 100px;
}

.navBtn {
  height: 65px;
  width: 88px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
}

.vr-left-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

a {
  color: rgba(93, 93, 93, 1);
}

.vr-container {
  position: relative;
  flex: 1;
  width: 100%;

  .visual {
    width: 40%;
    height: 30%;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    overflow: visible;
    opacity: 1;
    cursor: default;
    pointer-events: none;
    background: url(./assets/img/view_frame.png);
    background-size: 100% 100%;
    background-repeat: no-repeat no-repeat;

    &.active {
      background: url(./assets/img/view_frame_color.png);
      background-size: 100% 100%;
      background-repeat: no-repeat no-repeat;
    }
  }

  .visual-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 200px;

    .setAngleBtn {
      background-color: #7101ad;
      border-color: #7101ad;
    }
  }
}

.vr-group {
  flex: 0 0 143px;
  // padding:  0 0 0 88px;
  color: #505050;
  background-color: #919191;
}

.group-title {
  width: 100px;
  height: 35px;
  cursor: pointer;
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: white;
  flex-shrink: 0;
}

.group-title-name {
  width: 70px;
  font-size: 14px;
  padding: 4px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.group-title-options {
  flex: 0 0 30px;
  color: #505050;
  padding: 4px;
}

.group-top {
  height: 35px;
  padding: 0 20px;
  display: flex;
  justify-content: flex-start;
  overflow-y: hidden;
  overflow-x: auto;

  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    /**/
  }

  &::-webkit-scrollbar-track {
    background: #333;
    border-radius: 2px;
    box-shadow: none;
  }

  &::-webkit-scrollbar-thumb {
    background: #232323;
    border-radius: 3px;
    box-shadow: none;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #232323;
  }
}

.group-add-btn {
  width: 60px;
  font-size: 25px;
  cursor: pointer;
  text-align: center;
  flex-shrink: 0;
}

.group-bottom {
  height: 108px;
  background-color: #b9b9b9;
  // display: flex;
  // justify-content: flex-start;
  padding: 5px 5px 0 5px;

  .item-scroll-container {
    width: 100%;
    overflow: hidden;
    margin-right: 10px;

    .item-wrapper {
      display: flex;
      justify-content: flex-start;
      overflow-x: auto;
      height: 100px;

      &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        /**/
      }

      &::-webkit-scrollbar-track {
        background: #333;
        border-radius: 2px;
        box-shadow: none;
      }

      &::-webkit-scrollbar-thumb {
        background: #232323;
        border-radius: 3px;
        box-shadow: none;
      }

      &::-webkit-scrollbar-thumb:hover {
        background: #232323;
      }
    }
  }

  .item-scroll-container::-webkit-scrollbar {
    display: none;
  }
}

.item-bg {
  width: 70px;
  margin-right: 10px;
  user-select: none;
  cursor: pointer;

  .item-img {
    position: relative;
    width: 70px;
    height: 70px;
    border-radius: 4px;

    .scene-img {
      width: 70px;
      height: 70px;
      object-fit: contain;
    }

    .scene-option {
      position: absolute;
      top: 5px;
      right: 5px;
      width: 25px;
      height: 20px;
      background-color: rgba(0, 0, 0, 0.5);
      text-align: center;
      border-radius: 4px;
      z-index: 10;

      & > a {
        color: rgba(255, 255, 255, 0.8);
      }
    }

    .scene-option1 {
      position: absolute;
      bottom: 5px;
      right: 5px;
      width: 25px;
      height: 20px;
      background-color: rgba(0, 0, 0, 0.5);
      text-align: center;
      border-radius: 4px;
      z-index: 100;

      & > a {
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }

  .item-title {
    color: rgba(67, 67, 67, 1);
    font-size: 14px;
    line-height: 150%;
    text-align: center;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color: rgba(229, 229, 229, 1);
    /*background-color: rgba(0, 0, 0, 0.7);*/
    font-size: 12px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
}

.add-scenes {
  width: 70px;
  min-width: 70px;
  height: 70px;
  color: rgba(80, 80, 80, 1);
  border: 1px solid rgba(80, 80, 80, 1);
  /*line-height: 70px;*/
  text-align: center;
  cursor: pointer;
  padding-top: 15px;
  font-size: 0;

  /deep/ .anticon {
    font-size: 18px;
  }

  h4 {
    font-size: 12px;
    color: #606060;
    margin-top: 4px;
  }
}

.m-right-10 {
  margin-right: 10px;
}

.options-list {
  padding: 5px 0;
  color: #333;
  cursor: pointer;
  text-align: center;
}
.options-list-title {
  text-align: center;
  margin-bottom: 0;
}

.options-list:hover {
  color: #015c61;
}

.hide-scene {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  & > img {
    width: 20px;
    height: 20px;
  }
}

.wordHover:hover {
  color: #7101ad;
}

.icon-box {
  border: 1px solid #cccccc;
  border-radius: 5px;
  overflow: hidden;
  width: 100%;
  padding-bottom: 90%;
  height: 0;
  position: relative;
}

.jiahaoicon {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.delete-box {
  width: 20px;
  height: 20px;
  position: absolute;
  right: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.delete-icon {
  color: #ffffff;
}

.img-box {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.vr-left .navBtn button {
  height: 55px;
}

.vr-left .navBtn button i {
  font-size: 1.2rem;
  margin-top: 3px;
}

.vr-top button.ant-btn-primary,
.vr-left .navBtn button.ant-btn-primary {
  background-color: #404040;
  border-color: #2e2e2e;
}

.vr-top button.ant-btn-primary:hover,
.vr-left .navBtn button.ant-btn-primary:hover {
  background-color: #02767c;
  border-color: #015c61;
}

.vr-top .universeBtn button.ant-btn-primary:hover,
.vr-left .universe button.ant-btn-primary:hover {
  background-color: #7101ad;
  border-color: #7101ad;
}

.vr-left .active button.ant-btn-primary {
  background-color: #015c61;
  border-color: #015c61;
}

// .vr-left .universe button.ant-btn-primary {
//     background-color: #7101ad;
//     border-color: #7101ad;
// }

.vr-bg .setting-bg {
  /*padding-right: 90px;*/
  border-color: #4b4b4b #000 #000 #4b4b4b;
  border-style: solid;
  border-width: 1px;
  border-right: 0;
  border-bottom: 0;
}
</style>

<!--vr編輯.vr-bg的全局樣式-->
<style lang="less">
.ant-btn-primary {
  background-color: #015c61;
  border-color: #015c61;
}

.ant-btn-background-ghost.ant-btn-primary {
  color: #04a8b1;
  background-color: transparent;
  border-color: #04a8b1;
  text-shadow: none;
}

.selectBtn.ant-btn-background-ghost.ant-btn-primary {
  border-color: #d485ff;
  color: #d485ff;
}

.selectBtn.ant-btn-background-ghost.ant-btn-primary:hover {
  border-color: #e1aaff;
  color: #e1aaff;
}

.ant-slider-track {
  background-color: #04a8b1;
}

.rangeSlider .ant-slider-track,
.iconScaleSlider .ant-slider-track,
.titleXSlider .ant-slider-track,
.specialSlider .ant-slider-track {
  background-color: #d485ff;
}

.rangeSlider .ant-slider-track:hover {
  background-color: #d485ff;
}

.rangeSlider .ant-slider-handle,
.iconScaleSlider .ant-slider-handle,
.titleXSlider .ant-slider-handle,
.specialSlider .ant-slider-handle {
  border-color: #cf75ff;
}

.ant-btn-primary:hover {
  color: #fff;
  background-color: #04a8b1;
  border-color: #04a8b1;
}

.ant-btn-primary:focus {
  color: #fff;
  background-color: #04a8b1;
  border-color: #04a8b1;
}

.ant-btn-background-ghost.ant-btn-primary:hover {
  color: #05eefa;
  border-color: #05eefa;
}

.ant-radio-group-solid
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  color: #fff;
  background: #015c61;
  border-color: #015c61;
}

.vr-bg {
  /* 常用控件樣式start */

  .ant-input,
  .ant-select-selection,
  .ant-input-number-input {
    background-color: #2b2b2b !important;
    border: 1px solid #555;
    color: #fff;
  }

  .ant-input-number-input {
    text-align: center;
  }

  .ant-select-arrow,
  .ant-cascader-picker-arrow,
  .ant-cascader-picker {
    color: #fff;
  }

  /* 嵌入樣式 */

  .inject-home {
    padding: 20px;

    .addSceneBtn {
      background-color: #7101ad;
      border-color: #7101ad;
    }

    .linkHover:hover {
      background-color: #7101ad;
    }
  }

  /* 嵌入和熱點列表樣式 */

  .list-title {
    margin: 15px 0;
  }

  .list-bg {
    padding: 2px 0;
    width: 100%;
    height: 50px;
    align-items: center;
    display: flex;

    .content {
      cursor: pointer;
      height: 40px;
      background: #444;
      color: #fff;
      padding: 2px 0 2px 10px;
      border: 2px solid #444;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      .type {
        padding: 4px;
        background: #015c61;
        width: 24px;
        text-align: center;
      }

      .list-name {
        width: 100px;
        padding-left: 5px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .ant-dropdown-trigger {
        background: #444;
        color: #fff;
        border-color: #444;
        box-shadow: none;
      }
    }

    .selected {
      border: 2px solid #015c61;
    }
  }

  /* 熱點編輯樣式 */

  .tit-box {
    padding: 0px 20px;

    .tit-desc {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
      margin-top: 10px;
    }
  }

  /* 編輯時的熱點提交按鈕 */

  .btn-desc {
    display: flex;
    justify-content: space-between;
    margin: 40px 20px;
  }

  /* 分組列表 */

  .group-top {
    .group-title {
      height: 32px;
      color: #999;
    }

    .active {
      color: #fff;
      border-bottom: 2px solid #fff;
      // .group-title-name {
      //     border-bottom: 2px solid #fff;
      // }

      .group-title-options {
        a {
          color: #fff;
        }
      }
    }
  }

  .vr-top {
    border-color: #4b4b4b #000 #000 #4b4b4b;
    border-style: solid;
    border-width: 1px;
    background-color: #333;
    color: #333;
  }

  .title {
    color: #fff;
  }

  .close {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .vr-left {
    border-color: #4b4b4b #000 #000 #4b4b4b;
    border-style: solid;
    border-width: 1px;
    border-bottom: 0;
    background-color: #333;

    .active {
      background: none;
      border-bottom: 0;
    }
  }

  .vr-right {
    border-color: #4b4b4b #000 #000 #4b4b4b;
    border-style: solid;
    border-width: 1px;
    background-color: #333;
    border-bottom: 0;
    // width: 100%;
    width: calc(100% - 88px);
  }

  .group-top {
    border-color: #4b4b4b #000 #000 #4b4b4b;
    border-style: solid;
    border-width: 1px;
    background: #333;
    border-left: 0;
  }

  .group-bottom {
    border-color: #4b4b4b #000 #000 #4b4b4b;
    border-style: solid;
    border-width: 1px;
    background-color: #333;
    border-left: 0;
  }

  .item-bg {
    .item-img {
      background-color: #f3f3f3;
    }

    .item-title {
      color: #fff;
      margin-top: 3px;
    }
  }

  .setting-bg {
    .options-bg {
      border-color: #4b4b4b #000 #000 #4b4b4b;
      border-style: solid;
      border-width: 1px;
      border-top: 0;
      border-left: 0;
      border-bottom: 0;
    }
  }

  /*  .ant-card-head {
          background-color: #333;
          border-color: #4b4b4b #000 #000 #4b4b4b;
          border-style: solid;
          border-width: 1px;
          color: #fff;
        }*/

  .ant-card {
    background: #333;
    color: #fff;
    height: 100%;
    overflow: hidden;
  }

  .ant-card-head {
    /*border-color: #4b4b4b #000 #000 #4b4b4b;
            border-style: solid;
            border-bottom-width: 1px;
            border-top: 0;
            border-right: 0;
            border-left: 0;*/
    border: 0;
    border-bottom: 1px solid #000;
    margin-bottom: 0;
    color: #fff;
  }

  .ant-card-body {
    /*border-color: #4b4b4b #000 #000 #4b4b4b;
          border-style: solid;
          border-right: 0;
          border-left: 0;
          border-top-width: 1px;
          border-bottom: 0;*/
    border: 0;
    border-top: 1px solid #4b4b4b;
    height: calc(100% - 57px);
    overflow-y: auto;
  }

  .ant-form-item {
    color: #fff;
  }

  .ant-form-item-label > label {
    color: #fff;
  }

  .options-item {
    color: #fff;
  }

  span.ant-radio + * {
    color: #fff;
  }

  .options-content {
    background: #333;
    border-color: #4b4b4b #000 #000 #4b4b4b;
    border-style: solid;
    border-width: 1px;
    border-top: 0;
    padding-left: 1px;
    border-bottom: 0;
  }

  .drawer-content-wrapper .drawer-content .drawer-wrapper-body {
    border: 0;
    background: #333;
    border-color: #4b4b4b #000 #000 #4b4b4b;
    border-style: solid;
    border-width: 1px;
    border-right: 0;
    height: 100%;
  }

  .ant-checkbox + span {
    color: #fff;
  }

  #pano {
    background: #333;
  }
}

.aigenerateinform-btn {
  position: absolute;
  right: 15px;
  bottom: 15px;
  background-color: #fff;
  padding: 14px 12px;
  border-radius: 50px;
  cursor: pointer;
}

.screenShot {
  position: absolute;
  right: 15px;
  bottom: 15px;
  background-color: #404040;
  padding: 9px 14px 9px 13px;
  border-radius: 50px;
  cursor: pointer;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  img {
    width: 20px;
    height: 20px;
  }
  p{
    font-size: 14px;
    line-height: 14px;
    margin-bottom: 0;
  }
}
</style>
